module.exports = require("./khq");